﻿import { Component, OnInit} from '@angular/core';
import { RestService } from 'src/app/_services/rest.service';
import { Router } from '@angular/router';


@Component({ templateUrl: 'regalar.component.html' })
export class RegalarComponent implements OnInit {



    constructor(private restService: RestService, private router: Router) {
    }


    ngOnInit() {
        this.restService.getParam('regalo.anonimo').subscribe(data => {
            if (data.valor.toString().toUpperCase() != 'TRUE') {
                this.router.navigate(['/empezar']);
            }
        });
    }



}
